import { t } from '@lingui/core/macro';
export const rejectionMessage = (rejection) => {
    switch (rejection) {
        case 'CANNOT_NORMALIZE_NAMES':
            return t({
                message: 'Cannot normalize names',
                comment: 'Esigning contacts form rejection',
            });
        case 'MISSING_MOBILE_NUMBER':
            return t({
                message: 'Missing mobile number',
                comment: 'Esigning contacts form rejection',
            });
        case 'NOT_AUTHORIZED':
            return t({
                message: 'Not authorized',
                comment: 'Esigning contacts form rejection',
            });
        case 'NOT_FOUND':
            return t({
                message: 'Not found',
                comment: 'Esigning contacts form rejection',
            });
        default:
            return t({
                message: 'A error occurred while updating the contact',
                comment: 'Esigning contacts form rejection',
            });
    }
};
